import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { GridOverlay } from '@mui/x-data-grid';
import './SkeletonTabela.css';

const COLUNAS_LARGURA = [90, 140, 120, 120, 140, '1fr', 100, 150, 170];

const SkeletonTabelaInicial = () => (
  <Box className="skeleton-tabela-inicial">
    <Box className="skeleton-header-remessas">
      {COLUNAS_LARGURA.map((largura, i) => (
        <Skeleton
          key={i}
          variant="text"
          animation="wave"
          width={typeof largura === 'number' ? largura * 0.6 : '60%'}
          height={16}
          className="skeleton-header-cell"
        />
      ))}
    </Box>
    {Array.from({ length: 8 }).map((_, rowIdx) => (
      <Box
        key={rowIdx}
        className={`skeleton-row-remessas ${rowIdx % 2 === 0 ? 'skeleton-row-par' : 'skeleton-row-impar'}`}
      >
        {COLUNAS_LARGURA.map((largura, colIdx) => (
          <Skeleton
            key={colIdx}
            variant="rectangular"
            animation="wave"
            width={typeof largura === 'number' ? largura * 0.7 : '80%'}
            height={colIdx === 0 ? 28 : 14}
            className="skeleton-cell-remessas"
          />
        ))}
      </Box>
    ))}
    <Box className="skeleton-footer-remessas">
      <Skeleton variant="text" animation="wave" width={200} height={18} />
    </Box>
  </Box>
);

const SkeletonTabela = () => (
  <GridOverlay className="overlay-tabela-remessas">
    <Box className="skeleton-overlay-conteudo">
      {Array.from({ length: 8 }).map((_, rowIdx) => (
        <Box
          key={rowIdx}
          className={`skeleton-row-remessas ${rowIdx % 2 === 0 ? 'skeleton-row-par' : 'skeleton-row-impar'}`}
        >
          {COLUNAS_LARGURA.map((largura, colIdx) => (
            <Skeleton
              key={colIdx}
              variant="rectangular"
              animation="wave"
              width={typeof largura === 'number' ? largura * 0.7 : '80%'}
              height={colIdx === 0 ? 28 : 14}
              className="skeleton-cell-remessas"
            />
          ))}
        </Box>
      ))}
    </Box>
  </GridOverlay>
);

export { SkeletonTabelaInicial };
export default SkeletonTabela;
